(function () {
  function formatMoney(cents, format) {
    var rounded = Math.round(cents / 100);
    var withDecimals = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, rounded.toLocaleString())
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, rounded)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parseFloat(withDecimals).toLocaleString())
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
  }

  function updateBar(totalCents) {
    var bar = document.querySelector('.cart-shipping-bar');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold) return;
    var remaining = Math.max(0, threshold - totalCents);
    var pct = Math.min(100, Math.floor((totalCents / threshold) * 100));

    var fill = bar.querySelector('.cart-shipping-bar__fill');
    if (fill) fill.style.transform = 'scaleX(' + (pct / 100) + ')';

    var icon = bar.querySelector('.cart-shipping-bar__truck-icon');
    if (icon) icon.classList.toggle('cart-shipping-bar__truck-icon--reached', remaining === 0);

    var textEl = bar.querySelector('.cart-shipping-bar__text');
    if (!textEl) return;
    textEl.textContent = '';
    var strong = document.createElement('strong');
    if (remaining === 0) {
      strong.textContent = bar.dataset.textReached || '';
      textEl.appendChild(strong);
    } else {
      var fmt = formatMoney(remaining, bar.dataset.moneyFormat || '₪{{amount_no_decimals}}');
      strong.textContent = fmt;
      textEl.append((bar.dataset.textBefore || '') + ' ', strong, ' ' + (bar.dataset.textAfter || ''));
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { updateBar(c.total_price); })
      .catch(function () {});
  }

  function onCartEvent(event) {
    if (event && event.cartData && typeof event.cartData.total_price !== 'undefined') {
      updateBar(event.cartData.total_price);
    } else {
      fetchAndUpdate();
    }
  }

  function init() {
    fetchAndUpdate();
    if (typeof subscribe === 'function') {
      subscribe('cart-update', onCartEvent);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
